import { Car2PlusIcon } from './Car2PlusIcon';

/**
 * author: Michael Irigoyen
 * id 02A38C46-7F26-4A95-9025-33181E528B1C
 * name car-2-plus
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-2-plus.svg
 * tags
 * - Transportation + Road 
 * - Automotive 
 */
export const HighOccupancyVehicleLaneIcon = Car2PlusIcon;
export default HighOccupancyVehicleLaneIcon